// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Screen5_wrapper__tCxGO","title":"Screen5_title__2jwim","buySubscriptionLinkAccent":"Screen5_buySubscriptionLinkAccent__VJx3k"};